exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".chat {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%; }\n\n.message-list {\n  flex-grow: 1;\n  flex-shrink: 0;\n  height: calc(100vh - 170px - 1.9rem - 3rem - .188rem);\n  overflow-y: scroll;\n  padding-right: .633rem; }\n\n.message-list-title {\n  border-bottom: 0.2px solid #bbb;\n  height: 3rem;\n  margin-bottom: 0;\n  padding: 0 .188rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/chat/Chat.scss
// module id = 213
// module chunks = 0